<div class="photo-upload">
  <label>
    <i-tabler [name]="icon"></i-tabler>
    <span *ngIf="text" class="title">{{text}}</span>

    <input
      type="file"
      accept="image/*"
      [attr.capture]="action === 'camera' ? 'environment' : null"
      [attr.multiple]="true"
      hidden
      (change)="onFilesSelected($event)"
    />
  </label>
</div>